import {
  Card,
  Heading,
  Paragraph,
  Spinner,
} from "@digdir/designsystemet-react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useSetupAuthentication } from "@/features/auth";

export const Route = createFileRoute("/auth/callback")({
  component: AuthComponent,
  head: () => ({
    meta: [
      {
        title: "Omdirigerer | Norgespris for Fjernvarme",
      },
    ],
  }),
});

function AuthComponent() {
  useSetupAuthentication();
  const { t } = useTranslation();

  return (
    <div className="flex h-screen items-center justify-center">
      <Card className="max-w-xs">
        <div className="flex items-center justify-between">
          <Heading>{t("callback.logger-inn")}</Heading>
          <Spinner aria-hidden="true" data-size="sm" />
        </div>
        <Paragraph>{t("callback.venter")}</Paragraph>
      </Card>
    </div>
  );
}
